export const environment = {
    production: true,
    googleMapsApiKey: 'AIzaSyBzltAAfHtNBSvALm_7nWEg8FDVgdYwaQE', // Replace with your actual API key
    // baseApiUrl: 'https://167.71.208.69:9003',
    baseApiUrl: 'https://apiweb.nhfinance.com.kh/api'
  };
  